import type {DesignSelection} from '@Components/social-media/social-media.types';

export const MAX_UPLOADS_TO_DESIGNS = 10;

export interface WizardDesignActionsProps {
  designsToPublishTo: DesignSelection[];
  onDesignsStaged: (designs: DesignSelection[]) => void;
  onEditDesign: () => void;
  onEmbeddedEditorOpened: () => void;
  isLoadingEmbeddedEditor: boolean;
  setIsPreviewLoading: (loading: boolean) => void;
  setIsLoadingEmbeddedEditor: (loading: boolean) => void;
}
